<ng-container *ngIf="!isProductsPage">
  <div class="image-container-with-text" [ngStyle]="!isHomePage ? {'background-image': 'url(' + imageUrl + ')'} : {'background' : '#0C75D1'}">
  <div class="image-container-with-text__holder">
    <div class="image-container-with-text__text">
    <p l10nTranslate [innerHTML]="imageText">
    </p>
    <button  class="image-container-with-text__btn" [routerLink]="[routerButton]" l10nTranslate>{{buttonText}}</button>
    </div>
  </div>
</div>
</ng-container>

<ng-container *ngIf="isProductsPage">
  <div class="image-container-with-text" [ngStyle]="{'background-image': 'url(' + imageUrl + ')'}">
    <div class="image-container-with-text__holder">
      <div class="image-container-with-text__text image-container-with-text__page-product-grc-background">
        <div class="image-container-with-text__section-fab" l10nTranslate>
          {{type}}
        </div>
        <div class="image-container-with-text__page-product-grc">
          <div class="img-holder">
            <img [src]="subImgUrl" />
          </div>
          <div class="info-holder">
            <p [innerHTML]="imageText" l10nTranslate></p>
            <div l10nTranslate class="image-container-with-text__description" [innerHtml]="subTitle"></div>
            <button class="image-container-with-text__btn" [routerLink]="[routerButton]" l10nTranslate>{{buttonText}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
